import { Button, useModal } from "@fluidattacks/design";
import { Container } from "@fluidattacks/design";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { RequestSbomModal } from "../../request-sbom-modal";
import { useAuthz } from "hooks/use-authz";

interface ITableActionsProps {
  groupName: string;
}

const AllPackagesTableActions = (props: ITableActionsProps): JSX.Element => {
  const { groupName } = props;

  const { t } = useTranslation();
  const { canMutate } = useAuthz();
  const canRequestSbom = canMutate("request_sbom_file");

  const requestSbomModal = useModal("request-sbom-modal");
  const openSbomModal = useCallback((): void => {
    requestSbomModal.open();
  }, [requestSbomModal]);

  return (
    <Container display={"flex"} gap={1} justify={"flex-end"} width={"100%"}>
      {canRequestSbom ? (
        <Button
          id={t("group.toe.packages.btn.id")}
          onClick={openSbomModal}
          tooltip={t("group.toe.packages.btn.tooltip")}
          variant={"primary"}
        >
          {t("group.toe.packages.btn.text")}
        </Button>
      ) : undefined}
      {requestSbomModal.isOpen ? (
        <RequestSbomModal groupName={groupName} modalRef={requestSbomModal} />
      ) : undefined}
    </Container>
  );
};

export { AllPackagesTableActions };
